import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface PutCustomerCategoryRequest {
    id: number;
    product_category_idx: number[];
}
export const usePutCustomerCategory = (
    successCallback?: () => void,
): UseMutationResult<null, Error, PutCustomerCategoryRequest, unknown> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, PutCustomerCategoryRequest>({
        mutationFn: async ({ id, product_category_idx }: PutCustomerCategoryRequest) => {
            const response = await axios.put(
                `${enum_api_uri.put_customer_category.replace(":customer_idx", id.toString())}`,
                { product_category_idx },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: () => {
            successCallback?.();
        },
    });
};
